//package protection must have at least 10 variants to cart to rolling up to 10 products and 10th variant must have $9.99, max price
window.packageProtectionAlreadyAdded = false;
if (sessionStorage.getItem('package-protection-already-added') === "true" || sessionStorage.getItem('package-protection-already-added') === true){
    window.packageProtectionAlreadyAdded = true;
}
function returnVariantId(currentCartLength){
    if (currentCartLength < 10 && window.packageProtection.packageProtectionVariantId.length > currentCartLength){
        return window.packageProtection.packageProtectionVariantId[(currentCartLength - 1)]
    } else {
        return window.packageProtection.packageProtectionVariantId[window.packageProtection.packageProtectionVariantId.length - 1]
    }
}

function addProtectionToCart(variantId){
    let formData = {
        'items': [{
         'id': variantId,
         'quantity': 1
         }]
       };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         document.dispatchEvent(new CustomEvent('refresh-cart', {
            detail: {
              quantity: 1,
              target: window.packageProtectionHandle
            }
          }))
          if (quantity === 0){
            sessionStorage.setItem('package-protection-already-added', true)
            window.packageProtectionAlreadyAdded = true;
         }
       })
       .catch((error) => {
         console.error('Error:', error);
       });
}

function updateProtection(variantId, quantity){
    let updates = {};
    updates[variantId] = quantity;
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: updates
        })
    }).then(res => res.json()).then(data => {

            if(window.location.href.includes('cart')){
                window.location.reload()
            } else {
                document.dispatchEvent(new CustomEvent('refresh-cart', {
                    detail: {
                      quantity: quantity,
                      target: window.packageProtectionHandle
                    }
                  }))
            }
        })
}
function changeProtection(oldVariantId, currentCartQuantity){
        let updates = {};
        updates[oldVariantId] = 0;
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: updates
            })
        }).then(res => res.json()).then(data => {
                addProtectionToCart(returnVariantId(currentCartQuantity))
        })

}

function limitProtection(){
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
        data.items.forEach(item => {
            if (window.packageProtection.packageProtectionVariantId.includes(item.variant_id) && item.quantity > 1){
                updateProtection(item.variant_id, 1)
            } else if (window.packageProtection.packageProtectionVariantId.includes(item.variant_id) && data.items.length === 1){
                updateProtection(item.variant_id, 0)
            }
        })
    });
}

const packageProtectionElement = document.querySelector('.package-protection')

if (document.querySelector('.add-to-cart-re') || document.querySelector('.ProductForm__BuyButtons')){
    document.querySelectorAll('.add-to-cart-re, .ProductForm__BuyButtons').forEach(cartButton => {
        cartButton.querySelector('button').addEventListener('click',  () => {
            document.dispatchEvent(new CustomEvent('refresh-cart', {
                detail: {
                  quantity: 1,
                  target: 'product-handle-from-add-to-cart-button-click'
                }
              }))
        })
    })
}

document.addEventListener('refresh-cart', (e) => {
    let detailHandle;
    
    if (typeof e.detail !== 'undefined' || e.detail !== null){
        detailHandle = e.detail.target
        detailQuantity = e.detail.quantity
    }
    console.log('running cart package protection', detailHandle)
    if (detailHandle && detailHandle !== window.packageProtection.packageProtectionHandle && detailQuantity !== 0){
        setTimeout(function(){
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                    let cartHasPackageProtection = false;
                    let quantityValue = 0;
                    let currentVariantId;
                    data.items.forEach(item => {
                        if (window.packageProtection.packageProtectionVariantId.includes(item.variant_id)){
                            cartHasPackageProtection = true
                            currentVariantId = item.variant_id
                        } else {
                            quantityValue = quantityValue + item.quantity
                        }
                    })
                    if (cartHasPackageProtection && quantityValue === 0){
                                updateProtection(currentVariantId, 0)
                    } else if (cartHasPackageProtection) {
                        if (currentVariantId !== returnVariantId(quantityValue)){
                            changeProtection(currentVariantId, quantityValue)
                        }
                    } else {
                        if (!window.packageProtectionAlreadyAdded){
                            addProtectionToCart(returnVariantId(quantityValue))
                        }
                    }
             })
        }, 5)
    }
    limitProtection()
})
limitProtection()
document.dispatchEvent(new CustomEvent('refresh-cart', {
    detail: {
        quantity: 1,
        target: 'product-handle-from-cart-load'
    }
  }))
